import pingis from './img/tamburiinipingis_web.mp4';

export function Pingis() {
  return (
    <div className="container">
      <h1>Tamburiinipingis</h1>
      <p>
        POlympialaisissa musiikki ei pelasta urheilulta, eikä urheilu pelasta
        musiikilta. Katso video äänien kanssa, jotta audiovisuaalinen elämys
        pääsee oikeuksiinsa.
      </p>
      <video
        controls
        loop
        muted={true}
        autoPlay={true}
        className="pingis-video"
      >
        <source src={pingis} />
      </video>
    </div>
  );
}
